import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, spacing, radius, breakpoints, fonts, fontSize } = redesignTheme;

export const useBlockTypeMenuStyles = makeStyles(() => ({
  blockTypeMenu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: 8,
    width: 320,
    padding: spacing.md,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    zIndex: 20,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: 'min(320px, calc(100vw - 32px))',
      right: -8,
    },
  },
  blockTypeMenuTitle: {
    margin: `0 0 ${spacing.sm}px`,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
  },
  blockTypeGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: spacing.sm,
  },
  blockTypeItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.xs,
    padding: spacing.sm,
    borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
    cursor: 'pointer',
    '&:hover': {
      borderColor: colors.primaryDark,
      backgroundColor: colors.hoverSurface,
    },
  },
  blockTypeImage: {
    height: 49,
    objectFit: 'contain',
  },
  blockTypeLabel: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    color: colors.text,
    textAlign: 'center',
  },
  hiddenFileInput: {
    display: 'none',
  },
}));
